<template>
  <div class="all">
    <div class="header">
      <div class="logo"><img src="../assets/login/logo.png" alt=""></div>
      <div class="menu">
        <ul style="cursor: pointer; ">
          <li @click="$router.go(0)">保函申请</li>
          <li class="bao" >
            <p>保函查验</p>
            <p class="op" @click="open">安诚财险</p>
            <p class="op" @click="openAn">大家保险</p>
          </li>
          <!-- <li>保函资讯</li> -->
          <li>注册登录</li>
        </ul>
      </div>
      <div class="contact">
        <img src="../assets/login/phone-logo.png" alt="">
        <div>400-003-1733</div>
      </div>
    </div>
    <div class="main"  :style="{backgroundImage: 'url(' + backImg + ')'}">
      <div class="main_left">
        <!-- <img src="../assets/login/one.png" alt="" style="width:300px;"> -->
        <!-- <img src="../assets/login/two.png" alt="">
        <img src="../assets/login/three.png" alt="" style="width:200px;">
        <img src="../assets/login/four.png" alt="" style="width:160px;">
        <img src="../assets/login/code.png" style="width:100px;" alt=""> -->
      </div>
      <div class="main_right" :class="isPawrod?'':'ispass'">
        <div class="avatars">
          <img src="../assets/login/avatars.png" alt="">
        </div>
        <div class="top">
          <div class="user" :class="this.isCode ? '' : 'activ'" @click="codeBtn">验证码登录</div>
          <div class="user" :class="this.isCode ? 'activ' : ''" @click="user">账户登录</div>
        </div>
        <!-- 账号密码登录 -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm"
          style="width: 90%;margin: 0 auto;margin-top: 40px;" v-if="this.isCode">
          <el-form-item prop="account" style="margin-bottom:22px;">
            <el-input v-model="ruleForm.account" placeholder="请输入账号">
            </el-input>
          </el-form-item>
          <el-form-item prop="password" style="margin-bottom:22px">
            <el-input v-model="ruleForm.password" @keydown.enter.native="login('ruleForm')" show-password
              placeholder="请输入密码">
            </el-input>
          </el-form-item>
          <div style="text-align: center;margin-top: 30px;">
            <el-button
              style="width: 95%;height: 46px;background: #0972df;border-radius: 30px;font-size: 18px;font-family: SimHei;font-weight: 400;color: #FFFFFF;"
              @click="login('ruleForm')">登录</el-button>
          </div>
        </el-form>
        <!-- 验证码登录 -->
        <el-form :model="codeForm" :rules="codeRules" ref="codeForm" label-width="0px" class="demo-ruleForm"
          style="width: 90%;margin: 0 auto;margin-top: 40px;" v-if="!this.isCode">
          <el-form-item prop="phone" style="margin-bottom:22px">
            <el-input v-model="codeForm.phone" placeholder="请输入手机号">
            </el-input>
          </el-form-item>
          <el-form-item prop="code" style="margin-bottom:22px">
            <el-input v-model="codeForm.code" placeholder="请输入验证码" @keydown.enter.native="codeLogin('codeForm')">
              <template #suffix>
                <img v-if="showCodeMsg" @click="getCode" style="height:70%; cursor: pointer;"
                  src="../assets/login/code-bule.png" alt="">
                <p v-if="!showCodeMsg">{{ count }}重新获取</p>
              </template>
            </el-input>
          </el-form-item>
          <div style="text-align: center;margin-top: 30px;">
            <el-button
              style="width: 95%;height: 46px;background: #0972df;border-radius: 30px;font-size: 18px;font-family: SimHei;font-weight: 400;color: #FFFFFF;"
              @click="codeLogin('codeForm')">登录</el-button>
          </div>
        </el-form>
        <div v-if="isPawrod" style="display: flex;margin: 0 auto;justify-content: space-between;margin-top: 20px;">
          <div>
            <el-button type="text" @click="retrieve">忘记密码</el-button>
          </div>
          <div>
            <el-button type="text" @click="register">用户注册</el-button>
          </div>
        </div>
      </div>
    </div>
    <div >
      <div class="footer">
        <ul style="cursor: pointer;">
          <li>保函服务</li>
          <li @click="heton()">保险保函</li>
          <li @click="heton()">银行保函</li>
          <li @click="heton()">电子保函</li>
          <li @click="heton()">履约保函</li>
        </ul>
        <ul >
          <li>友情链接</li>
          <li><a style="color: inherit" href="https://www.haneton.com" target="_blank">函驿通</a></li>
          <li><a style="color: inherit" href="http://dfdd-toubiaole.com" target="_blank">东方大地保险经纪有限公司</a></li>
          <li><a style="color: inherit" href="https://www.hebca.com" target="_blank">河北CA</a></li>
          <li><a style="color: inherit" href="https://www.e-acic.com" target="_blank" rel="noreferrer">安诚财险</a></li>
          <li><a style="color: inherit" href="https://e.djbx.com" target="_blank">大家财险</a></li>
        </ul>
        <ul>
          <li>联系我们</li>
          <li>服务热线：400-003-1733</li>
          <li>电子邮箱：haneton@163.com</li>
          <li>公司地址：河北省石家庄市新华区中华北大街27号鑫明商务中心211</li>
        </ul>
        <div class="qrcode">
          <div class="official">
            <img src="../assets/login/code.png" alt="">
            <p>乾保网官方客服</p>
          </div>
          <!-- <div class="official">
            <img src="../assets/5b41f45cf2935c2306dce2347945cbb.png" alt="">
            <p>公众号</p>
          </div> -->
        </div>
      </div>
      <div style="display: flex; justify-content: center;font-size: 12px;color: #bbb;">
        <p>
          <a style="color: #bbb; text-decoration: none;" href="https://beian.miit.gov.cn/" target="_blank">ICP备:鄂ICP备16015336号-5</a>
        </p>
        <p style="margin-left:20px;">
          <a>公安备案号:11010502048927</a>
        </p>
      </div>
    </div>

    <el-dialog class="dialog" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" @close="closedialog" :destroy-on-close="true">
      <!-- 重置密码 -->
      <div v-if="isRetrieve" style="width: 100%; height: 100%;">
        <div
          style="font-family: 黑体;border-radius:10px 10px 0 0;font-weight: 400;height:50px;line-height:50px;font-style: normal;font-size: 18px;overflow:hidden;letter-spacing: 5px;color: #fff; background-color: #0065b3; text-align: center;">
          重置密码</div>
        <el-form :model="findForm" :rules="findRules" ref="findForm" label-width="100px" class="demo-ruleForm"
          style="padding: 0 100px;margin-top: 20px;">
          <el-form-item label="账号" prop="account">
            <el-input v-model="findForm.account" placeholder="2~15位，支持汉字、字母、数字格式" style="width:70%;"></el-input>
            <el-button type="text" style="margin-left:2%" @click="findAccout">忘记账号，点击找回</el-button>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input show-password style="width:70%;" v-model="findForm.password" placeholder="6~20位，包含大、小写字母，数字至少各1个">
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="affirm">
            <span class="befor_2">*</span>
            <el-input show-password style="width:70%;" v-model="findForm.affirm" placeholder="6~20位，包含大、小写字母，数字至少各1个">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <span class="befor_3">*</span>
            <el-input v-model="findForm.phone" placeholder="请输入手机号" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input style="width: 70%" v-model="findForm.code" placeholder="请输入短信验证码"></el-input>
            <el-button type="primary"
              style="margin-left: 20px; width: 98px;background: #0065b3;border-radius: 0;border:0" @click="sendMsgTwo"
              :disabled="isDisabled2">{{ code2 }}</el-button>
          </el-form-item>
          <el-form-item style="text-align: center; margin: 19px 100px 0 0">
            <el-button type="primary" style="background: #0065b3;border-radius: 0;border:0" @click="returnLogin">返回登录
            </el-button>
            <el-button type="primary" style="background: #0065b3;border-radius: 0;border:0"
              @click="submitfind('findForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 用户注册 -->
      <div v-if="isRegister" style="width: 100%;height: 100%;">
        <div
          style="font-family: 黑体;border-radius:10px 10px 0 0;font-weight: 400;height:50px;line-height:50px;font-style: normal;font-size: 18px;overflow:hidden;letter-spacing: 5px;color: #fff; background-color: #0065b3; text-align: center;">
          新用户注册</div>
        <el-form :model="enrollForm" :rules="enrollRules" ref="enrollForm" label-width="120px" class="demo-ruleForm"
          style="padding: 0 100px;margin-top: 20px;">
          <el-form-item label="账号" prop="account">
            <el-input v-model="enrollForm.account" placeholder="2~15位，支持汉字、字母、数字格式"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input show-password v-model="enrollForm.password" placeholder="6~20位，包含大、小写字母，数字至少各1个"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="affirm">
            <span class="befor_2">*</span>
            <el-input show-password v-model="enrollForm.affirm" placeholder="6~20位，包含大、小写字母，数字至少各1个"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <span class="befor_3">*</span>
            <el-input v-model="enrollForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input style="width: 70%" v-model="enrollForm.code" placeholder="请输入短信验证码"></el-input>
            <el-button type="primary"
              style="margin-left: 20px; width: 98px;background: #0065b3;border-radius: 0;border:0" @click="sendMsgThree"
              :disabled="isDisabled3">{{ code3 }}</el-button>
          </el-form-item>
          <div style="text-align: center">
            <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
            <el-button type="text" style="padding: 0" @click="userServiceAgreement">《用户服务协议》</el-button>
          </div>
          <el-form-item style="text-align: center; margin: 19px 100px 0 0">
            <el-button type="primary" style="background: #0065b3;border-radius: 0;border:0" @click="returnLogin">返回登录
            </el-button>
            <el-button type="primary" style="background: #0065b3;border-radius: 0;border:0"
              @click="submitenroll('enrollForm')" :disabled="!checked">&nbsp;&nbsp;注&nbsp;册&nbsp;&nbsp;</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 找回账号 -->
      <div v-if="isFind" style="width: 100%;height:100%; position: relative;">
        <div
          style="font-family: 黑体;border-radius:10px 10px 0 0;font-weight: 400;height:50px;line-height:50px;font-style: normal;font-size: 18px;overflow:hidden;letter-spacing: 5px;color: #fff; background-color: #0065b3; text-align: center;">
          找回账号</div>
        <el-form :model="accountForm" :rules="accountRules" ref="accountForm" label-width="90px" class="demo-ruleForm"
          style="padding: 0 120px;margin-top: 20px;">
          <el-form-item prop="phone" label="手机号：">
            <el-input v-model="accountForm.phone" placeholder="请输入手机号">
            </el-input>
          </el-form-item>
          <el-form-item prop="code" label="验证码：">
            <el-input v-model="accountForm.code" placeholder="请输入短信验证码" style="width:70%">
            </el-input>
            <el-button @click="sendMsgFour" :disabled="isDisabled4"
              style="background: #0065b3;border:0;color:#fff;margin-left:3%; width:27%">{{ code4 }}</el-button>
          </el-form-item>
          <el-form-item style="text-align:center;">
            <el-button style="background: #0065b3;border:0;color:#fff;" @click="accountFind('accountForm')">找回账号
            </el-button>
          </el-form-item>
          <!-- 显示查询到的账号 -->
          <div style="margin-top:40px;font-size:14px;" v-if="this.isShow">
            <div>
              您的登录账号为:<span style="margin-left:10px;">{{ this.find }}</span>
            </div>
            <div style="text-align:right;margin-top:20px;">
              <el-button @click="copyTemplate" style="background: #0065b3;border:0;color:#fff;" size="medium">复制</el-button>
            </div>
          </div>
          <div style="position: absolute;bottom:10px;left: 50%;transform: translate(-50%,0);">
            <el-button style="font-size:18px;" type="text" @click="returnLogin">返回登录</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <div class="happy">
      <el-dialog
      title=""
      :visible.sync="userVisible"
      top="18vh"
      width="48%">
        <div style="font-size: 16px;padding: 0px 15px 120px 15px;">
          <p style="text-align: center;font-size: 22px;font-weight: bold;margin-bottom: 23px;">2024年国庆节放假通知</p>
        <p>尊敬的用户：</p>
        <p style="text-indent: 2em">
          平台根据国家节假日放假规定，结合公司实际情况，研究决定：
        </p>
        <p style="text-indent: 2em">公司放假安排：2024年10月01日--10月07日</p>
        <p style="text-indent: 2em">正式上班时间：10月08日</p>
        <p style="text-indent: 2em;">
          放假期间如需咨询可留言客服，客服看到后将在上班后第一时间回复您，由此带来的不便，敬请谅解！
        </p>
        <p style="float: right; margin-top: 80px">河北筑正科技有限公司</p>
      </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };

    const validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.findForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.enrollForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isCode: false,//判断选择验证码登录
      ruleForm: {
        account: "",
        password: "",
      },
      codeForm: {
        phone: "",
        code: "",
      },
      findForm: {//重置密码
        account: "",
        password: "",
        affirm: "",
        phone: "",
        code: "",
      },
      accountForm: {
        phone: "",
        code: "",
      },//找回账号
      enrollForm: {
        account: "",
        password: "",
        affirm: "",
        phone: "",
        code: "",
      },
      enrollRules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 2, max: 12, message: "2~15位，支持汉字、字母、数字格式" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "6~20位，包含大、小写字母，数字至少各1个,并且不能包含特殊符号",
          },
          {
            pattern:
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9]{6,20}$/,
            message: "6~20位，包含大、小写字母，数字至少各1个,并且不能包含特殊符号",
            trigger: "blur",
          },
        ],
        affirm: [{ validator: validatePass2, trigger: "blur" }],
        phone: [{ validator: phoneRules, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      codeRules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
      accountRules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
      findRules: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 2, max: 12, message: "2~15位，支持汉字、字母、数字格式" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "6~20位，包含大、小写字母，数字至少各1个,并且不能包含特殊符号",
          },
          {
            pattern:
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9]{6,20}$/,
            message: "6~20位，包含大、小写字母，数字至少各1个,并且不能包含特殊符号",
            trigger: "blur",
          },
        ],
        affirm: [{ validator: validatePass1, trigger: "blur" }],
        phone: [{ validator: phoneRules, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      find: "",
      isShow: false,//复制账号
      dialogVisible: false,//弹框
      isRetrieve: false,//重置密码
      isDisabled2: false,//验证码
      isDisabled3: false,
      isFind: false,//找回账号
      isRegister: false,//用户注册
      isDisabled4: false,
      code2: "立即获取",
      code4: "立即获取",
      code3: "立即获取",
      time: 59,
      checked: false,
      timer: null,//定时器
      count: "",//读秒
      showCodeMsg: true,//重新获取
      backImg: '',
      isPawrod:false,
      userVisible:false,//放假通知
    };
  },
  created() { 
    console.log(this.$route.query.aa)
    if (this.$route.query.referrerName&&this.$route.query.referrerPhone) {
      this.backImg = require('../assets/new_home/login-new.png')
      this.isPawrod=false
    }
    else {
      this.backImg = require('../assets/login/login-bc.png')
      this.isPawrod=true
    }
  },
  mounted() { 
    this.isTimeBefore()
  },
  methods: {
    //用户密码登录,验证码登录
    codeBtn() {
      this.$refs.ruleForm.clearValidate()
      this.isCode = false
    },
    user() {
      this.$refs.codeForm.clearValidate()
      this.isCode = true
    },
    findAccout() {
      this.$refs.findForm.clearValidate()
      this.isFind = true;
      this.isRetrieve = false;
      this.isRegister = false;
    },
    returnLogin() {
      this.dialogVisible = false
      this.isRetrieve = false;
      this.isRegister = false;
      this.isFind = false;
    },
    closedialog(){
      for( const key in this.findForm){
        this.findForm[key]=''
      }
      for( const key in this.accountForm){
        this.accountForm[key]=''
      }
      for( const key in this.enrollForm){
        this.enrollForm[key]=''
      }
      this.find = ""
      this.isShow=false
    },
    register() {
      this.dialogVisible = true
      this.isRetrieve = false;
      this.isRegister = true;
      this.isFind = false;
    },
    retrieve() {
      this.dialogVisible = true
      this.isRetrieve = true
      this.isRegister = false;
      this.isFind=false
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/userLogin",
            data: {
              userName: this.ruleForm.account,
              passWord: this.ruleForm.password,
              from: "33",
              referrerName: this.$route.query.referrerName,
              referrerPhone:this.$route.query.referrerPhone
            },
          }).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              window.sessionStorage.setItem("username", res.data.data.username);
              window.sessionStorage.setItem("userId", res.data.data.id);
              window.sessionStorage.setItem("phoneNum", res.data.data.phoneNum);
              this.$router.push("/home");
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    codeLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            // url: "/loginController/userLoginByPhone",
            url: '/loginController/phoneRegister',
            data: {
              phoneNum: this.codeForm.phone,
              randCode: this.codeForm.code,
              from: "33",
              registSource: '1',
              referrerName: this.$route.query.referrerName,
              referrerPhone:this.$route.query.referrerPhone
            },
          }).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "登录成功",
                type: "success",
              });
              window.sessionStorage.setItem("username", res.data.data.username);
              window.sessionStorage.setItem("userId", res.data.data.id);
              window.sessionStorage.setItem("phoneNum", res.data.data.phoneNum);
              this.$router.push("/home");
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    sendMsgTwo() {
      this.$refs.findForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              checkFlag: "find",
              phoneNum: this.findForm.phone,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              let me = this;
              me.isDisabled2 = true;
              let interval = window.setInterval(function () {
                me.code2 = me.time;
                --me.time;
                if (me.time < 0) {
                  me.code2 = "重新发送";
                  me.time = 59;
                  me.isDisabled2 = false;
                  window.clearInterval(interval);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
        }
      });
    },
    getCode() {
      this.$refs.codeForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              phoneNum: this.codeForm.phone,
              checkFlag: "register",
              from: "33"
            }
          }).then(res => {
            if (res.data.status == 1) {
              const timcount = 60;
              if (!this.timer) {
                this.count = timcount;
                this.showCodeMsg = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= timcount) {
                    this.count--;
                  } else {
                    this.showCodeMsg = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            }
            else if (res.data.status == -3) {
              this.axios({
                method: "POST",
                url: "/loginController/getRCode",
                data: {
                  phoneNum: this.codeForm.phone,
                  checkFlag: "find",
                  from: "33"
                }
              }).then(resp => {
                if (resp.data.status == 1) {
                  const timcount = 60;
                  if (!this.timer) {
                    this.count = timcount;
                    this.showCodeMsg = false;
                    this.timer = setInterval(() => {
                      if (this.count > 0 && this.count <= timcount) {
                        this.count--;
                      } else {
                        this.showCodeMsg = true;
                        clearInterval(this.timer);
                        this.timer = null;
                      }
                    }, 1000)
                  }
                }
                else {
                  this.$message({
                    message: resp.data.statusInfo,
                    type: "error",
                  });
                }
              })
            }
            else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          })
        }
      })
    },
    sendMsgThree() {
      this.$refs.enrollForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              checkFlag: "register",
              phoneNum: this.enrollForm.phone,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              let me = this;
              me.isDisabled3 = true;
              let interval = window.setInterval(function () {
                me.code3 = me.time;
                --me.time;
                if (me.time < 0) {
                  me.code3 = "重新发送";
                  me.time = 59;
                  me.isDisabled3 = false;
                  window.clearInterval(interval);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
        }
      });
    },

    sendMsgFour() {
      this.$refs.accountForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              checkFlag: "find",
              phoneNum: this.accountForm.phone,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              let me = this;
              me.isDisabled4 = true;
              let interval = window.setInterval(function () {
                me.code4 = me.time;
                --me.time;
                if (me.time < 0) {
                  me.code4 = "重新发送";
                  me.time = 59;
                  me.isDisabled4 = false;
                  window.clearInterval(interval);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
        }
      });
    },
    submitfind(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/findPassWord",
            data: {
              userName: this.findForm.account,
              newPassWord: this.findForm.password,
              confirmPassWord: this.findForm.affirm,
              phoneNum: this.findForm.phone,
              randCode: this.findForm.code,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "修改密码成功,请进行登录",
                type: "success",
              });
              this.dialogVisible = false;
              this.isRetrieve = false;
              this.isRegister = false;
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    submitenroll(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/userRegister",
            data: {
              userName: this.enrollForm.account,
              passWord: this.enrollForm.password,
              confirmPassWord: this.enrollForm.affirm,
              phoneNum: this.enrollForm.phone,
              randCode: this.enrollForm.code,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "注册成功,请进行登录",
                type: "success",
              });
              this.dialogVisible = false;
              this.isRetrieve = false;
              this.isRegister = false;
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    accountFind(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/findUserName",
            data: {
              phoneNum: this.accountForm.phone,
              randCode: this.accountForm.code,
              from: "33",
            },
          }).then((res) => {
            if (res.data.status == 1) {
              this.find=res.data.data
              this.$message({
                message: "账号找回成功！",
                type: "success",
              });
              this.isShow=true
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    userServiceAgreement() {
      // this.userVisible = true;
    },
    copyTemplate() {
      this.copyToClipboard(this.find); 
      this.$message.success('复制成功');
    },
    copyToClipboard(content) {
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
    },
    open() {
      window.open('https://www.e-acic.com/AcicWebManager/template/ContentServlet?params=17956C20939A85CA7A0E231BF2CD92680EE4AFA51C8FADB09EB2D60A40740ED18AD3843DFEDA2BF980A3098BF4B7FCCB94FCF28D61ECD116BD242BEC55534F4AE8BAC5F14E88985584DF31A95F33C2BCE098E258A0A66D62DE951E509CF59E90C1AA9F0D22E99C3065BD77757F0FAFC3C1A27104154BD131D9EE531A53334E572B6C212767F362E5AA3B39FFACA422C4B8A9B2F27E6DB9A2A1308442682EA2F5B08E9278E38937EC89546A157363D7A0098F1C0EFF7E41DFEBEEAD90F1F33263','_blank','noreferrer')
    },
    openAn() {
      window.open('https://e.djbx.com/service/subService.html?serviceName=creditEnquiry','_blank')
    },
    heton() { 
      window.open('https://www.haneton.com','_balnk')
    },
    isTimeBefore() {
      const targetTime = '2024-10-08'
      const currentTime = new Date();
      const target = new Date(targetTime);
      this.userVisible = currentTime < target;
    }
  },

}
</script>

<style lang="less" scoped>
* {
  list-style: none;
}

.all {
  height: 100%;
  font-family: none;
}

.header {
  height: 65PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15%;
}

.menu {
  height: 100%;
}

.menu ul {
  display: inline-flex;
  height: 65PX;
  line-height: 62PX;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.bao{
  cursor: pointer; 
  overflow: hidden;
  background-color: #ffffff;
  height: 62PX;
  margin: 0 !important;
  padding: 0 30PX;
  transition: all .3s ease-in-out;
}
.op{
  height: 45PX;
}
.op:hover{
  border-bottom: 3PX solid #ffa854;
}
.bao:hover{
  height: 168PX;
}

.menu ul li {
  margin: 0 30PX;
  font-size: 17PX;
}

.menu ul li:last-child {
  border-bottom: 3PX solid #ffa854;
}

.contact {
  display: inline-flex;
  align-items: center;
  color: #ffa854;
  font-size: 26PX;
  font-weight: bold;
}

.main {
  background: url('../assets/login/login-bc.png') no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 10% 15% 6% 15%;
  display: flex;
  justify-content: space-between;

}

.main_left {
  width: 400PX;
  height: 400PX;
  display: flex;
  flex-direction: column;
}

.main_left img {
  margin-bottom: 20PX;
}
.ispass{
  height: 360PX !important;
}

.main_right {
  box-sizing: border-box;
  width: 400PX;
  height: 400PX;
  background-color: #f7f7f7;
  border-radius: 20PX;
  padding: 40PX;
  position: relative;
}

.avatars {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.avatars img {
  width: 100PX;
}

.main_right .top {
  display: flex;
  justify-content: center;
  font-size: 23PX;
}

.main_right .top .user {
  padding: 10PX 20PX;
  cursor: pointer;
}

.main_right .top .activ {
  color: #40a2ec;
  border-bottom: solid 2PX #40a2ec;
}

.footer {
  padding: 2% 15% 0 15%;
  display: flex;
  justify-content: space-around;
}

.footer ul {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.footer ul li:first-child {
  font-size: 20PX;
  font-weight: 500;
  margin-bottom: 20PX;
}

.footer ul li {
  margin-bottom: 6PX;
  font-size: 13PX;
}

.official {
  font-size: 13PX;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.official p {
  margin: 0;
  padding: 5PX 0;
}

.official img {
  width: 100PX;
}

.official:first-child {
  margin-bottom: 10PX;
}

::v-deep .dialog .el-dialog__body {
  width: 100%;
  height: 100%;
  padding: 0;
}

::v-deep .dialog .el-dialog__header {
  display: none;
}

::v-deep .dialog .el-dialog {
  width: 800PX;
  height: 480PX;
  background: #FFFFFF;
  border-radius: 10PX;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 2PX 12PX 0 rgba(0, 0, 0, 0.1);
}


::v-deep .el-input__suffix {
  display: flex;
}

::v-deep .el-input__suffix-inner {
  display: flex;
  align-items: center;
}

.befor_2 {
  position: absolute;
  left: -92PX;
  color: #f56c6c;
}

.befor_3 {
  position: absolute;
  left: -64PX;
  color: #f56c6c;
}

.el-button+.el-button {
  margin-left: 20PX;
}
.happy{
  // ::v-deep .el-dialog__body{
  //   padding: 0;
  // }
  // ::v-deep .el-dialog__header{
  //   padding: 0;
  // }
  p{
    line-height: 27PX;
  }
  letter-spacing:1.5PX;
}
::v-deep .el-dialog {

  border-radius: 8PX;
}
</style>